import { render, staticRenderFns } from "./inputMoeda.vue?vue&type=template&id=791ac0f0&"
import script from "./inputMoeda.vue?vue&type=script&lang=js&"
export * from "./inputMoeda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports